import { ESymbolType } from '@webtrader/core/api/market/symbols/index';
import request from '@webtrader/core/request';

export interface ISymbolTypeList {
  symbolTypeList: ESymbolType[];
}

const symbolCategories = () => {
  return request.get<ISymbolTypeList>('/api/market/v1/symbol/category');
};

export default symbolCategories;
